export default __webpack_public_path__ + "static/media/comitelep.c02b62bc.jpg";